export enum CacheEntities {
  COMEDIAN = "comedian",
  PODCAST = "podcast",
  SPECIAL = "special",
  COLLECTION_SPECIALS = "collection_specials", // Cache key namespace for specials within a collection
  NEWSLETTER_AD = "newsletter_ad",
  USER = "user",
  TOP_COMEDIANS_EMAIL = "top_comedians_email", // Cache key for formatted top comedians for email
  NEW_SPECIALS_EMAIL = "new_specials_email", // Cache key for formatted new specials for email
  SPECIALS_LAST_28D_EMAIL = "specials_last_28d_email", // Cache key for specials fetched for email
  VENUE_PAGE = "venue_page", // Cache key for venue data
  VENUE_PAGE_THEME = "venue_page_theme", // Public venue page theme colours by slug
  VENUE_PAGE_NAME = "venue_page_name", // Venue name for the dashboard tab title, by slug
  VENUE_PAGE_SHOWS = "venue_page_shows", // Public venue page upcoming shows (with live availability) by venue id
  VENUE_EMAIL_FEATURED_SHOWS = "venue_email_featured_shows", // A venue email's public featured-shows landing page data, by job id + venue slug
  VENUE_PAGE_SHOW_GROUP = "venue_page_show_group", // Public venue page show-group drill-down (resolved series + Tixologi events) by venue slug + group slug
  EMAIL_NEWSLETTER_USER = "email_newsletter_user",
  NEWSLETTER_SENT = "newsletter_sent", // Idempotency tracking for sent newsletters
  EMAIL_BATCH_SENT = "email_batch_sent", // Idempotency tracking for sent email batches
  PAGE_GROUP_MEMBERS = "page_group_members",
  VENUE_TICKETING_EVENTS = "venue_ticketing_events", // Proxied upstream events for the developer Venue Shows API
  RELEASE_BOARD = "release_board", // The public release board's published-entries list (packages/data server/internal/releases)
  TIXOLOGI_EVENT_INACTIVE = "tixologi_event_inactive", // Per-event memo of the Tixologi `inactive` (unpublished) flag, for batch jobs
  TIXOLOGI_EVENT_HIDDEN = "tixologi_event_hidden", // Per-event memo of "password protected or hidden upstream", for batch jobs
}
